module.exports = __webpack_public_path__ + "img/module_ysbbfx_icon.56238789.png";